import HeroSection from "./components/HeroSection";
import CasesSection from "./components/CasesSection";
import MidCtaSection from "./components/MidCtaSection";
import ConsultFormSection from "./components/ConsultFormSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "作品介紹｜速築美宅家 Chronos Space",
  "description": "查看速築美宅家 Chronos Space 自地自建、危老重建、家族土地、多代同堂、農地景觀宅與退休宅等作品案例，找到你的理想住宅參考。",
  "about": {
    "@type": "Thing",
    "name": "建築作品集"
  },
  "isPartOf": {
    "@type": "WebSite",
    "name": "速築美宅家 Chronos Space",
    "url": siteUrl
  }
};

export default function Portfolio() {
  return (
    <main>
      <SEOMeta
        title="作品介紹"
        description="查看速築美宅家 Chronos Space 自地自建、危老重建、家族土地、多代同堂、農地景觀宅與退休宅等作品案例，找到你的理想住宅參考。"
        keywords="建築作品集,自地自建案例,危老重建作品,鋼構住宅實績,建築設計作品"
        canonicalPath="/portfolio"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <CasesSection />
      <MidCtaSection />
      <ConsultFormSection />
      <FinalCtaSection />
    </main>
  );
}